import type { Finding } from './Finding'
import { FindingFromJSON, FindingToJSON } from './Finding'
import type { Pagination } from './Pagination'
import { PaginationFromJSON, PaginationToJSON } from './Pagination'

/**
 *
 * @export
 * @interface FindingsResponse
 */
export interface FindingsResponse {
  /**
   *
   * @type {Array<Finding>}
   * @memberof FindingsResponse
   */
  items: Finding[]
  /**
   *
   * @type {Pagination}
   * @memberof FindingsResponse
   */
  pagination: Pagination
}

/**
 * Check if a given object implements the FindingsResponse interface.
 */
export function instanceOfFindingsResponse(value: object): boolean {
  if (!('items' in value)) {return false}
  if (!('pagination' in value)) {return false}
  return true
}

export function FindingsResponseFromJSON(json: any): FindingsResponse {
  return FindingsResponseFromJSONTyped(json, false)
}

export function FindingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FindingsResponse {
  if (json == null) {
    return json
  }
  return {
    items: (json.items as any[]).map(FindingFromJSON),
    pagination: PaginationFromJSON(json.pagination)
  }
}

export function FindingsResponseToJSON(value?: FindingsResponse | null): any {
  if (value == null) {
    return value
  }
  return {
    items: (value.items as any[]).map(FindingToJSON),
    pagination: PaginationToJSON(value.pagination)
  }
}
